module.exports = __webpack_public_path__ + "img/12.0225a60d.png";